import { render, staticRenderFns } from "./penalty-chart.vue?vue&type=template&id=74feba1a&scoped=true"
import script from "./penalty-chart.vue?vue&type=script&lang=js"
export * from "./penalty-chart.vue?vue&type=script&lang=js"
import style0 from "./penalty-chart.vue?vue&type=style&index=0&id=74feba1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74feba1a",
  null
  
)

export default component.exports